import { render, staticRenderFns } from "./ClassCreate.vue?vue&type=template&id=fceed2de&scoped=true"
import script from "./ClassCreate.vue?vue&type=script&lang=js"
export * from "./ClassCreate.vue?vue&type=script&lang=js"
import style0 from "./ClassCreate.vue?vue&type=style&index=0&id=fceed2de&prod&scoped=true&lang=css"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fceed2de",
  null
  
)

export default component.exports